module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA27.w.1.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA27"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.28.0.0.box.382.311.1094.225.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA27.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_heading",
    staticStyle: {
      "font-variant": "small-caps"
    },
    attrs: {
      "id": "para.28.0.0.box.792.311.276.38.q.90"
    }
  }, [_vm._v("CHAPTER 2")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA27.w.0.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_heading",
    attrs: {
      "id": "para.28.0.1.box.382.427.1094.109.q.90"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA27.w.2.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA28"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA28.w.0.0.0"
    }
  }), _vm._v("Appetizers and Snacks")])]), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.28.1.0.box.332.943.1198.1351.q.101"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA29"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA29.w.0.0.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0018.jpg"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA29.w.0.0.0.1"
    }
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA29.w.0.0.0.2"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA29.w.1.0.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA29"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.30.0.0.box.523.305.797.55.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA29.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_h1_heading",
    attrs: {
      "id": "para.30.0.0.box.523.305.797.55.q.70"
    }
  }, [_vm._v("Frank's Cajun-Style Fried Rumaki")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.30.1.0.box.225.422.1390.212.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA29.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.30.1.0.box.225.422.1390.212.q.60"
    }
  }, [_vm._v("It's the best of the Orient combined with the best of the Bayou Country . . . marinated chicken livers dusted in seasoned flour, wrapped in bacon, and deep-fried to a succulent crispness. They're just what you need for your next party or elegant meal!")])]), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.30.2.0.box.229.717.1343.363.q.30"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA29.w.1.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA29.w.1.2.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA29.w.1.3.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA29.w.1.4.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA29.w.1.5.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0019.png"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA29.w.1.5.0.1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.30.3.0.box.228.1166.1396.1409.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA29.w.3.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.30.3.0.box.229.1166.1388.103.q.40"
    }
  }, [_vm._v("First, take a 21A-qt. glass bowl "), _c('i', [_vm._v("(do ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("not ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("use ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("metal!) ")]), _vm._v("and mix together 2 cups milk and the onions.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA29.w.3.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.30.3.1.box.228.1276.1390.206.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA29.w.1.6.0"
    }
  }), _vm._v("In the meantime, drain the chicken livers and remove any traces of fat that may still be attached. Now drop them into the milk mixture and allow them to marinate for at least 3-4 hours (overnight is even better!).")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA29.w.3.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.30.3.2.box.230.1493.1394.431.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA29.w.1.7.0"
    }
  }), _vm._v("Then when you're ready to cook, lay out the bacon strips on the countertop. Then take one liver directly from the milk marinade, dust it lightly in the seasoned flour, and wrap it so that it's completely enclosed in a bacon strip. "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Note: ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("if ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("you ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("don't ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("dust ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("it ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("in ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("flour ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("first, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("it'll ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("slip ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("and ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("slide ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("all ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("over ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("place ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("and ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("you'll ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("never ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("get ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("it ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("to ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("stay ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("inside ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("bacon!")]), _vm._v("Then pin the bacon strip in place with a toothpick. Repeat this procedure with each liver. When they're all done, place them momentarily on the countertop on a sheet of waxed paper.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA29.w.3.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.30.3.3.box.230.1930.1390.361.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA29.w.1.8.0"
    }
  }), _vm._v("At this point, heat the oil to exactly 325 degrees in a heavy deepsided skillet. When you're ready to fry, lightly dust the rolled livers in the seasoned flour once again, but be sure to shake off all the excess. Then drop them gently into the oil and fry them on both sides until the bacon turns a golden brown and the flour coating becomes crispy. "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Just ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("be ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("sure ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("you ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("don't ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("overcook ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("them, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("otherwise ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("bacon ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("will ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("burn. ")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA29.w.3.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.30.3.4.box.230.2309.1389.266.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA29.w.1.9.0"
    }
  }), _vm._v("When they're ready, set them aside temporarily on a warming platter. Then in a 2V2-qt. saucepan, add about 6 tbsp. of the corn oil you used to fry the livers in, mix in about 6-8 tbsp. seasoned flour, and make a light roux. You only need to cook it for a few minutes because you don't want it to brown (you're going to make country-style"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA30.w.0.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.31.0.0.box.353.309.1392.213.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA30"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA30.w.0.0.0"
    }
  }), _vm._v("\nwhite-milk gravy here). Now stir in about 2 cups milk plus the canned chicken broth and simmer everything together over "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("low ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("heat ")]), _vm._v("until the gravy turns silky smooth. At this point, you can season it with salt and black pepper to taste.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA30.w.0.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA30"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.31.0.0.box.353.309.1392.589.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA30.w.0.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.31.0.1.box.354.528.1384.322.q.50"
    }
  }, [_vm._v("When you're ready to eat, all you do is dish up 4-6 of the Cajunstyle rumaki bundles for each person and cover them generously with the milk gravy. If you want to make a meal out of these, serve them alongside a big scoop of cheesy grits or mashed potatoes or dirty rice and, maybe, a tossed green salad topped with bleu cheese dressing.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA30.w.0.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.31.0.2.box.404.856.377.42.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA30.w.0.2.0"
    }
  }), _vm._v("Oooh, cher! Ah-so!")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.31.1.0.box.355.965.1388.200.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA30.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.31.1.0.box.355.965.1388.200.q.50"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA30.w.0.3.0"
    }
  }), _vm._v("Chef's ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Note: ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("For ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("best ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("flavor, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("I ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("suggest ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("you ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("season ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("flour ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("to ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("taste ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("with ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("my ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Frank ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Davis ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Sprinkling ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Spice ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("(plus ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("1-2 ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("dashes ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Frank ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Davis ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Poultry ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Seasoning). ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("My ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("seasonings ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("can ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("be ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("ordered ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("from ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("my ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Web ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("site, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("www.frankda ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("vis. ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("com. ")])])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.31.2.0.box.354.1396.1385.540.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA30.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_h1_heading",
    attrs: {
      "id": "para.31.2.0.box.449.1396.1197.52.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA30.w.1.0.0"
    }
  }), _vm._v("Frank's Almost-World-Famous Buffalo Hot Wings")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA30.w.2.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.31.2.1.box.354.1510.1385.426.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA30.w.1.1.0"
    }
  }), _vm._v("Nobody really knows the true, coveted, secret recipe for Buffalo Chicken Wings, except for the one person who legend says created it back in 1964 at the Anchor Bar and Grill in Buffalo, New York. That person is Teresa Bellissimo. And last we heard, she wasn't about to give anyone her time-honored formulation. But not to worry. This concoction t'ain't all that bad, and it's about as close to the real thing as anyone outside the Bellissimo family will ever get. So whip up a batch of these real soon and enjoy!")]), _c('a', {
    attrs: {
      "id": "GBS.PA30.w.2.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA30.w.2.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA30.w.2.2.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA30.w.2.3.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA30.w.2.4.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA30.w.2.5.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA30.w.3.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.31.3.0.box.357.2051.1327.383.q.30"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA31"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA31.w.0.0.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0020.png"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA31.w.0.0.0.1"
    }
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA31.w.0.0.0.2"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA31.w.1.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA31.w.1.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA31.w.1.2.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA31"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.32.0.0.box.218.305.1387.266.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA31.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.32.0.0.box.218.305.1387.266.q.60"
    }
  }, [_vm._v("Just in case you want to make your own Roquefort dip instead of using store bought, do this first, because it must chill for at least 3 hours. Put all the dip ingredients into a nonreactive bowl (preferably glass) and combine thoroughly. Then cover with plastic wrap and chill. This keeps well in the refrigerator for about 10 days.")])]), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.32.1.0.box.220.690.1380.194.q.30"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA31.w.1.3.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0021.png"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA31.w.1.3.0.1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.32.2.0.box.219.964.1394.1249.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA31.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.32.2.0.box.220.964.1386.267.q.50"
    }
  }, [_vm._v("When you're ready to make the wings, in a heavy, high-sided fry pan, heat the oil to 375-400 degrees. Some recipes say you can bake, grill, or broil the wings, but you really don't have \"authentic\" Buffalo wings unless you deep-fry 'em in small batches. Hot-wing lovers know that this is not a heart-healthy dish!")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA31.w.2.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.32.2.1.box.219.1237.1389.267.q.60"
    }
  }, [_vm._v("It is important that you first wash the wings in cold running water. Then with a super-sharp knife, split them at the joints (discard the wing tips), pat them well with paper towels, and air dry them on a rack in the refrigerator. This procedure alone will ensure crispy wings once they are deep-fried.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA31.w.2.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.32.2.2.box.221.1510.1392.376.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA31.w.1.4.0"
    }
  }), _vm._v("Next, simply dust them "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("very ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("lightly ")]), _vm._v("in the chicken fried mix—"), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("do ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("not ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("dip ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("them ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("in ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("an ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("egg ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("wash ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("and ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("coat ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("them ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("with ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("a ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("batter. ")]), _vm._v("The only reason you even want them floured is because the light coating helps to keep the sauce on the wings. I also recommend that if possible you separate the drumettes from the mid-wing sections and fry them separately—the drumettes will take a few minutes longer to cook than the mid-wings.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA31.w.2.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.32.2.3.box.221.1892.1387.321.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA31.w.1.5.0"
    }
  }), _vm._v("When you're ready to fix 'em, drop about 15 wings at a time into the hot oil (each wing piece should be submerged in the oil—you want to deep-fry 'em, not pan-fry 'em). Then fry the batch for 12-14 minutes, stirring them occasionally. You can figure they're done when the rapidly bubbling of the oil subsides significantly in the skillet. A couple of batches and you'll get the hang of it!")])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA32"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA32.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA32.w.0.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA32.w.0.2.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA32.w.0.3.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA32.w.0.4.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA32"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.33.0.0.box.306.303.1189.385.q.30"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA32.w.0.5.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0022.png"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA32.w.0.5.0.1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.33.1.0.box.304.778.1394.1785.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA32.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.33.1.0.box.305.778.1384.261.q.60"
    }
  }, [_vm._v("In the meantime, while the wings are frying, make the sauce. In a 3-qt. saucepan, first melt the margarine. Then briskly stir in the hot sauce, vinegar, and spices. But once everything is totally combined, remove the pan from the fire right away! Cooked too long over the flame, the sauce will break.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA32.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.33.1.1.box.305.1052.1387.485.q.60"
    }
  }, [_vm._v("When it's time for the wings to come out of the hot oil, simply lift them out either with a slotted spoon or a pair of tongs and place them immediately on either paper towels or brown grocery bags to drain. Then put them into an extra-large stainless-steel bowl, ladle the sauce over them, and toss them briskly to liberally coat each wing part. The trick to getting them \"just right\" is to toss them with \"just the right amount\" of sauce. You don't want them dripping with sauce— you're not marinating them. And the more sauce you use, the hotter they will become.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA32.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.33.1.2.box.306.1542.1385.210.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA32.w.0.6.0"
    }
  }), _vm._v("All that's left to do now is place the wings on a shallow baking sheet, slide them into a preheated 400-degree oven for about 5 minutes or so to bake on the sauce, and then serve them with celery sticks, carrot sticks, and a big bowl of Roquefort dip. This sho' is some fine vittles!")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA32.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.33.1.3.box.360.1812.249.37.q.70"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA32.w.0.7.0"
    }
  }), _vm._v("Chefs ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Note: ")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA32.w.1.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.33.1.4.box.309.1865.1386.157.q.60"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA32.w.0.8.0"
    }
  }), _vm._v("1")]), _vm._v("—"), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("For ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("ultimate ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("in ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Buffalo ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Hot ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Wings, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("try ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("to ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("buy ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("what ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("are ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("called ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("\"grinders,")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("\" ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("extra-meaty, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("extra-large, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("unfrozen ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("chicken ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("wings. ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("They ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("are, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("however, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("sometimes ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("hard ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("to ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("find. ")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA32.w.1.5.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.33.1.5.box.304.2028.1391.157.q.40"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA32.w.0.9.0"
    }
  }), _vm._v("2")]), _vm._v("—"), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("If ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("you ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("don't ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("have ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("any ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Frank ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Davis ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Chicken ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Fried ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Mix, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("you ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("can ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("use ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("all-purpose ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("flour ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("mixed ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("with ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("1 ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("tsp. ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("kosher ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("salt ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("and ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("1 ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("tsp. ")]), _c('i', [_vm._v("coarse-")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("ground ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("black ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("pepper. ")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA32.w.1.6.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.33.1.6.box.308.2190.1390.156.q.60"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA32.w.0.10.0"
    }
  }), _vm._v("3")]), _vm._v("—"), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("If ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("you ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("don't ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("have ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("any ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Frank ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Davis ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Garlic ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Cayenne ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Hot ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Sauce ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("on ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("hand, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("you ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("can ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("use ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("your ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("favorite ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("bottled ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("hot ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("sauce ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("instead. ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Just ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("remember ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("to ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("adjust ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("heat ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("intensity ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("to ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("your ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("taste. ")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA32.w.1.7.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.33.1.7.box.308.2352.1389.211.q.50"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA32.w.0.11.0"
    }
  }), _vm._v("4")]), _vm._v("—"), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("The ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("basic ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("formula ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("for ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("hot ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("sauce ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("is ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("x ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("amount ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("of ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("margarine ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("to ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("x ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("amount ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("of ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("hot ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("sauce ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("(with ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("a ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("little ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("BBQ ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("sauce")]), _vm._v("—"), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("but ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("not ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("hickory ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("fla")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("vored!")]), _vm._v("—"), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("tossed ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("in ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("to ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("tone ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("down ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("heat ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("a ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("little ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("if ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("so ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("desired). ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("But ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("to ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("control ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("heat ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("intensity ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("of ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("sauce, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("simply ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("do ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("following: ")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA33"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA33.w.0.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA33.w.0.0.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA33.w.0.1.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA33"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.34.0.0.box.208.313.1397.595.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA33.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.34.0.0.box.261.313.1155.50.q.60"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("For ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("mild ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("sauce, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("use ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("equal ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("parts ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("hot ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("sauce ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("and ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("margarine. ")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA33.w.0.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.34.0.1.box.208.369.1393.103.q.60"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("For ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("medium ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("sauce, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("use ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("twice ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("amount ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("of ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("hot ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("sauce ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("as ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("mar")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("garine. ")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA33.w.0.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.34.0.2.box.208.477.1393.104.q.70"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA33.w.0.2.0"
    }
  }), _vm._v("For ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("killer ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("sauce, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("use ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("three ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("times ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("amount ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("of ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("hot ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("sauce ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("as ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("mar")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("garine. ")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA33.w.0.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.34.0.3.box.211.587.1391.104.q.60"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA33.w.0.3.0"
    }
  }), _vm._v("For ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("kiddie ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("wings, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("just ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("splash ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("a ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("few ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("drops ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("of ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("hot ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("sauce ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("into ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("margarine. ")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA33.w.0.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.34.0.4.box.214.696.1391.212.q.60"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA33.w.0.4.0"
    }
  }), _vm._v("5")]), _vm._v("—"), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("If ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("you ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("don't ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("have ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("a ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("large ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("stainless-steel ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("bowl, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("you ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("can ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("put ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("wings ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("into ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("a ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("large ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("container ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("with ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("a ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("cover, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("pour ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("on ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("sauce, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("cover ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("container, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("and ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("shake ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("it ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("briskly ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("until ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("each ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("of ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("wings ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("is ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("thor")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("oughly ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("coated. ")])])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.34.1.0.box.212.1127.1387.274.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA33.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_h1_heading",
    attrs: {
      "id": "para.34.1.0.box.617.1127.574.43.q.90"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA33.w.1.0.0"
    }
  }), _vm._v("Microwaved Artichoke")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA33.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.34.1.1.box.212.1242.1387.159.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA33.w.2.0.0"
    }
  }), _vm._v("I can't begin to tell you how many dozens of ways there are to prepare the vegetable pride of Sicily—artichokes. Believe it or not, microwaving is one of them (and it yields elegant results, too).")])]), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.34.2.0.box.213.1482.1271.205.q.30"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA33.w.2.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA33.w.2.2.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA33.w.2.3.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA33.w.2.4.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA33.w.2.5.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0023.png"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA33.w.2.5.0.1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.34.3.0.box.212.1771.1390.796.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA33.w.3.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.34.3.0.box.212.1771.1390.376.q.60"
    }
  }, [_vm._v("First, wash the artichoke thoroughly under cool running water, making sure that the water flows between all of the leaves. Then cut off the stem flush with the bottom of the artichoke, and slice off the top third of the artichoke (at this time it's a good idea to peel away the smallest outer leaves, too). When it is fully prepped, place it trimmed side down on a couple of sheets of paper towels (in other words, the stem side should be facing up).")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA33.w.3.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.34.3.1.box.213.2152.1385.103.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA33.w.2.6.0"
    }
  }), _vm._v("Now put the remaining ingredients in a Tupperware-type bowl that has a lid. Stir everything together until fully blended.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA33.w.3.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.34.3.2.box.213.2260.1388.156.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA33.w.2.7.0"
    }
  }), _vm._v("All that's left to do is to place the artichoke facedown in the bowl and cover it with the lid (but leave a slight crack in the seal to allow the excess moisture to vent). Now cook the artichoke for 7 minutes on high.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA33.w.3.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.34.3.3.box.213.2421.1387.146.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA33.w.2.8.0"
    }
  }), _vm._v("When the cooking time has elapsed, remove the artichoke from the microwave; but leave the cover on the bowl and let the artichoke stand for an additional 5 minutes.")])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA34"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA34.w.0.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA34"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.35.0.0.box.339.315.1389.159.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA34.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.35.0.0.box.339.315.1389.159.q.60"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Chefs ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Note: ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("When ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("you're ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("ready ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("to ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("eat, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("pull ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("off ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("leaves ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("and ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("dip ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("them ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("in ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("an ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("olive ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("oil, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("balsamic ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("vinegar, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("black ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("pepper, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("and ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("grated ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Parmesan ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("cheese ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("mixture ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("that ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("you ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("make ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("to ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("taste. ")])])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.35.1.0.box.336.693.1173.163.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA34.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_h1_heading",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "para.35.1.0.box.736.693.588.43.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA34.w.1.0.0"
    }
  }), _vm._v("Pot-Cooked Artichokes")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA34.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.35.1.1.box.336.808.1173.48.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA34.w.2.0.0"
    }
  }), _vm._v("This is one of the easiest ways to prepare artichokes, y'all.")])]), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.35.2.0.box.338.937.1341.261.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA34.w.2.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA34.w.2.2.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA34.w.2.3.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA34.w.2.4.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA34.w.2.5.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA34.w.2.6.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0024.png"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA34.w.2.6.0.1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.35.3.0.box.336.1281.1385.860.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA34.w.3.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.35.3.0.box.337.1281.1384.157.q.50"
    }
  }, [_vm._v("Take a heavy, nonreactive boiling pot with a tight-fitting lid and add the water or stock. Now season the \"pot liquor\" with salt, pepper, cayenne, oil, and herbs.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA34.w.3.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.35.3.1.box.337.1444.1384.197.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA34.w.2.7.0"
    }
  }), _vm._v("Now trim the chokes. You do this by cutting off the stems flush with the bottoms and slicing off the thistle ends (about 1A of the way down from the top). At this point, take time to stick garlic slivers between most of the leaves.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA34.w.3.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.35.3.2.box.337.1660.1384.265.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA34.w.2.8.0"
    }
  }), _vm._v("Now, with the pot liquor boiling, place the artichokes right side up into the water, cover the pot tightly with the lid, reduce the heat to simmer, and steam the chokes for 30-40 minutes, depending upon their size. They are done when the leaves pull away from the globes easily.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA34.w.3.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.35.3.3.box.336.1931.1385.210.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA34.w.2.9.0"
    }
  }), _vm._v("When they're done, drain them and cool them slightly. Pot-boiled artichokes can be eaten immediately or refrigerated and eaten later. I personally like to dip the leaves in a sauce of drawn butter and lemon juice (1 stick melted butter plus the juice of 1 lemon).")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.35.4.0.box.334.2201.1394.156.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA34.w.4.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.35.4.0.box.334.2201.1394.156.q.60"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA34.w.2.10.0"
    }
  }), _vm._v("Chef's ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Note: ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Do ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("not ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("cook ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("artichokes ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("in ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("aluminum ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("or ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("cast-iron ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("cookware. ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("These ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("metals ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("will ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("discolor ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("chokes. ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Stainless ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("steel ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("is ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("preferred. ")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA35"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA35.w.0.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA35.w.0.0.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA35.w.1.0.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA35"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.36.0.0.box.225.312.1024.162.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA35.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_h1_heading",
    attrs: {
      "id": "para.36.0.0.box.593.312.656.43.q.80"
    }
  }, [_vm._v("Sicilian Stuffed Artichokes")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA35.w.0.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.36.0.1.box.225.426.821.48.q.70"
    }
  }, [_vm._v("This preparation is the ultimate favorite!")])]), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.36.1.0.box.228.555.1275.204.q.30"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA35.w.1.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA35.w.1.2.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA35.w.1.3.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0025.png"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA35.w.1.3.0.1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.36.2.0.box.228.844.1392.865.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA35.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.36.2.0.box.279.844.943.49.q.60"
    }
  }, [_vm._v("First, cut the stems and tops off the artichokes.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA35.w.2.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.36.2.1.box.228.899.1388.212.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA35.w.1.4.0"
    }
  }), _vm._v("Now, in a large stainless-steel bowl, mix together the cheese, garlic, breadcrumbs, and pepper. Then place each artichoke down into the bowl of breading, spread the leaves with your thumbs, and stuff each layer of leaves—"), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("from ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("inside ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("out")]), _vm._v("—with the mixture.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA35.w.2.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.36.2.2.box.228.1117.1387.157.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA35.w.1.5.0"
    }
  }), _vm._v("At this point, place the artichokes right side up in a nonreactive pot with a lid that has about 2 in. water in the bottom. Then drizzle the oil and lemon juice equally over the tops of the chokes.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA35.w.2.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.36.2.3.box.228.1280.1388.211.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA35.w.1.6.0"
    }
  }), _vm._v("All that's left to do is to cover the pot, set the fire on simmer, and steam the artichokes for about 45 minutes or so, checking occasionally that the water has not completely evaporated. The chokes are done when the leaves can be pulled off easily.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA35.w.2.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.36.2.4.box.232.1551.1388.158.q.60"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA35.w.1.7.0"
    }
  }), _vm._v("Chef's ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Note: ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("To ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("make ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("a ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("richer ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("bread ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("stuffing, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("pour ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("just ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("enough ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("olive ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("oil ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("into ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("breadcrumb ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("mixture ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("to ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("give ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("it ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("a ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("slightly ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("moist, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("crumbly ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("consistency. ")])])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.36.3.0.box.230.1928.1387.379.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA35.w.3.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_h1_heading",
    attrs: {
      "id": "para.36.3.0.box.231.1928.1382.51.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA35.w.2.0.0"
    }
  }), _vm._v("Mary Clare's Baked Artichokes with Garlic and Sausage")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA35.w.3.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.36.3.1.box.230.2041.1387.266.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA35.w.2.1.0"
    }
  }), _vm._v("If you'd like one of the easiest, no-hassle methods of fixin' artichokes (that you don't have to keep monitoring minute to minute), you'll like this one that my wife, Mary Clare, fixes for me as a special snackin' treat. I'm guessing this could be your favorite way to eat these bad boys!")])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA36"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA36.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA36.w.0.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA36.w.0.2.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA36.w.0.3.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA36.w.0.4.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA36.w.0.5.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA36.w.0.6.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA36"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.37.0.0.box.365.307.1375.369.q.30"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA36.w.0.7.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0026.png"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA36.w.0.7.0.1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.37.1.0.box.366.766.1394.1342.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA36.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.37.1.0.box.366.766.1388.322.q.60"
    }
  }, [_vm._v("First off, prep your artichokes. Then before you begin cooking, take a melon bailer and scoop out the thistle-like center of each choke (along with the inedible purple-tinged leaves). Follow this procedure by thoroughly rubbing down the cut portions of the artichokes with the lemon to keep the chokes from turning black. Oh, yeah—and in the meantime, preheat the oven to 350 degrees.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA36.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.37.1.1.box.368.1093.1388.484.q.60"
    }
  }, [_vm._v("Next, mix together the garlic and oil. Then meticulously fold in all of the Romano cheese and the vegetable seasoning. When the mixture is fully blended, spread the artichoke leaves apart and—"), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("with ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("a ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("teaspoon")]), _vm._v("—put a little of the mixture in between the leaves of each artichoke (as well as in the scooped-out center). When the chokes are filled, roll a wad of sausage about the size of a golf ball between your palms until it is perfectly rounded. Then pack it tightly into the hollowed-out center of an artichoke (it is okay to overstuff the artichoke center slightly). Repeat for the other artichokes.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA36.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.37.1.2.box.369.1581.1386.213.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA36.w.0.8.0"
    }
  }), _vm._v("All that's left to do at this point is to put the artichokes into a baking dish, pour the stock and wine in the bottom, cover the dish securely with aluminum foil, and bake the artichokes for approximately 1 hour (or until the leaves can be pulled off easily).")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA36.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.37.1.3.box.419.1801.1040.48.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA36.w.0.9.0"
    }
  }), _vm._v("These you can serve warm or at room temperature.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA36.w.1.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.37.1.4.box.373.1907.1387.201.q.60"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA36.w.0.10.0"
    }
  }), _vm._v("Chef's ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Note: ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Use ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("only ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("a ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("good ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("dry ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("white ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("wine ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("when ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("cooking ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("arti")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("chokes. ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Artichokes ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("have ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("tendency ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("to ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("make ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("wine ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("taste ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("sweeter, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("so ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("a ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("naturally ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("sweet ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("wine ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("would ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("not ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("be ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("very ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("compatible ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("with ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("char")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("acteristics ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("of ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("artichoke. ")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA37"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA37.w.0.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA37.w.0.0.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA37.w.1.0.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA37"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.38.0.0.box.219.321.1388.328.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA37.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_h1_heading",
    attrs: {
      "id": "para.38.0.0.box.567.321.693.53.q.80"
    }
  }, [_vm._v("Frank's Snacking Artichokes")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA37.w.0.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.38.0.1.box.219.436.1388.213.q.60"
    }
  }, [_vm._v("Poached artichokes dipped in their own special sauce might just be the perfect ultra-light meal for those hot and humid summer evenings in Southeast Louisiana, while still providing all the low-fat nutrition your body needs. Give 'em a try.")])]), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.38.1.0.box.221.768.1215.278.q.30"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA37.w.2.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA37.w.3.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA37.w.3.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA37.w.4.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA37.w.4.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA37.w.5.0.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0027.png"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA37.w.5.0.0.1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.38.2.0.box.221.1135.1389.856.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA37.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.38.2.0.box.221.1135.1388.213.q.60"
    }
  }, [_vm._v("First, take a large stockpot (with a lid) capable of holding all 4 artichokes and bring the water to a rapid boil. Then while the water is at a full boil, stir in and completely dissolve the salt. Then whisk in the red pepper flakes.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA37.w.2.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.38.2.1.box.221.1354.1389.266.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA37.w.5.1.0"
    }
  }), _vm._v("At this point, place the artichokes down into the pot. Note that the water will stop boiling. But immediately when the boil returns, lower the fire, put the lid on the pot, and simmer the chokes slowly for about 1 hour (or until an ice pick easily pierces the leaves and heart through and through).")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA37.w.2.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.38.2.2.box.222.1626.1387.158.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA37.w.5.2.0"
    }
  }), _vm._v("When the chokes are done, remove them from the pot and set them on a platter on the countertop so that they can cool to room temperature.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA37.w.2.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.38.2.3.box.223.1791.1385.200.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA37.w.5.3.0"
    }
  }), _vm._v("When the artichokes a"), _c('a', {
    attrs: {
      "id": "GBS.PA37.w.6.0.0"
    }
  }), _vm._v("re cool enough to han"), _c('a', {
    attrs: {
      "id": "GBS.PA37.w.7.0.0"
    }
  }), _vm._v("dle, pull apart the l"), _c('a', {
    attrs: {
      "id": "GBS.PA37.w.7.1.0"
    }
  }), _vm._v("eaves and place them on a platter. Then sc"), _c('a', {
    attrs: {
      "id": "GBS.PA37.w.7.2.0"
    }
  }), _vm._v("rape away the burr fr"), _c('a', {
    attrs: {
      "id": "GBS.PA37.w.8.0.0"
    }
  }), _vm._v("om the artichoke hear"), _c('a', {
    attrs: {
      "id": "GBS.PA37.w.8.1.0"
    }
  }), _vm._v("ts, cut the hearts in"), _c('a', {
    attrs: {
      "id": "GBS.PA37.w.8.2.0"
    }
  }), _vm._v("to bite-size chunks, and set them aside on"), _c('a', {
    attrs: {
      "id": "GBS.PA37.w.9.0.0"
    }
  }), _vm._v(" a dish.")])]), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.38.3.0.box.223.2120.1384.439.q.20"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA38"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA38.w.0.0.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0028.png"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA38.w.0.0.0.1"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA38"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.39.0.0.box.305.315.1395.813.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA38.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.39.0.0.box.308.315.1386.321.q.60"
    }
  }, [_vm._v("While the artichokes are cooling, it's a perfect time to make the sauce you'll be dipping the leaves into. In a large stainless-steel bowl (or in a food processor or drink blender), beat together the oil, vinegar, garlic, anchovies, cheese, Sicilian seasoning, and pepper. In fact, it's probably more accurate to say \"emulsify\" the mixture to a creamy consistency.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA38.w.0.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.39.0.1.box.309.643.1384.158.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA38.w.0.1.0"
    }
  }), _vm._v("Just before you serve a bowl of the dipping sauce to your family or friends, you can sprinkle the sauce lightly with the breadcrumbs if you wish, in order to give the dip a richer Italian flavor.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA38.w.0.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.39.0.2.box.305.862.1395.266.q.60"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA38.w.0.2.0"
    }
  }), _vm._v("Chefs ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Note: ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("This ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("recipe ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("is ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("ideally ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("served ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("as ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("an ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("appetizer ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("or ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("snack. ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Simply ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("take ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("a ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("stack ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("of ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("leaves")]), _vm._v("—"), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("they ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("can ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("be ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("hot ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("or ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("cold")]), _vm._v("—"), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("and ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("plunge ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("them ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("one ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("at ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("a ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("time ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("into ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("dipping ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("sauce ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("before ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("placing ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("them ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("into ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("your ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("mouth. ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Then ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("scrape ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("away ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("artichoke ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("pulp ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("(and ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("sauce) ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("from ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("leaves ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("with ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("your ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("teeth. ")])])]), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.39.1.0.box.308.1346.1259.342.q.40"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA38.w.1.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA38.w.2.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA38.w.2.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA38.w.2.2.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA38.w.3.0.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0029.png"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA38.w.3.0.0.1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.39.2.0.box.310.1830.1382.101.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA38.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.39.2.0.box.310.1830.1382.101.q.70"
    }
  }, [_vm._v("Very simply, mix all the ingredients together. Then chill briefly and serve as an all-around artichoke dip.")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.39.3.0.box.310.2148.1387.487.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA38.w.3.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_h1_heading",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "para.39.3.0.box.671.2148.664.52.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA38.w.4.0.0"
    }
  }), _vm._v("Frank's Snacking Edamame")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA38.w.3.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.39.3.1.box.310.2261.1387.374.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA38.w.5.0.0"
    }
  }), _vm._v("The next time you feel the snacking urge coming on, before you reach for the beer nuts, pretzels, potato chips, nachos, cheese balls, popcorn, cakes, cookies, or ice cream, check the freezer to see if you have any edamame on hand. If you do, you got yourself a great snack. If you don't, head out to the Asian food store and pick up a frozen 1-lb. bag of these Japanese soybeans. Then you're gonna boil them and prepare their own special dipping sauce!")])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA39"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA39.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA39.w.0.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA39.w.0.2.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA39.w.0.3.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA39.w.0.3.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA39.w.0.4.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA39"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.40.0.0.box.227.316.1377.153.q.40"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA39.w.0.5.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0030.png"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA39.w.0.5.0.1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.40.1.0.box.225.555.1389.706.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA39.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.40.1.0.box.225.555.1388.267.q.60"
    }
  }, [_vm._v("Preparation of these super-healthy and exceptionally tasty beans is probably amongst the easiest in the world. Very simply, you bring the water and 1 tsp. salt to a rapid boil in a large saucepan or wok. Then you drop in the entire contents of the package of beans—while they're still frozen.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA39.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.40.1.1.box.226.828.1387.213.q.70"
    }
  }, [_vm._v("The water will immediately stop boiling. But when boiling resumes, cover the pan and cook the edamame for exactly 6 minutes. At the end of the allotted time, immediately drain the beans and serve them (either hot or at room temperature).")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA39.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.40.1.2.box.225.1048.1389.213.q.60"
    }
  }, [_vm._v("If you care to, you can scatter a little kosher salt or sprinkling spice over the hot shells and toss them in the bowl a couple of times, thereby adding a little more seasoning to the dish. Most fans of edamame, however, also dip the shells in an Asian dipping sauce.")])]), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.40.2.0.box.227.1376.1172.220.q.30"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA39.w.1.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA39.w.1.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA39.w.1.2.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA39.w.1.3.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0031.png"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA39.w.1.3.0.1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.40.3.0.box.221.1680.1399.537.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA39.w.3.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.40.3.0.box.225.1680.1390.211.q.50"
    }
  }, [_vm._v("All you do is put all of the sauce ingredients in a small bowl or ramekin and mix thoroughly. It's just that easy! Oh, and you can make a couple of batches of it, too, because it keeps well in the fridge for at least a couple of weeks.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA39.w.3.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.40.3.1.box.221.1950.1399.267.q.60"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA39.w.1.4.0"
    }
  }), _vm._v("Chefs ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Note: ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("The ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("rich, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("green, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("nutty-flavored ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("beans ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("pop ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("out ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("of ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("shells ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("very ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("easily. ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("To ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("eat ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("them, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("you ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("can ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("either ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("shell ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("them ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("first ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("so ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("that ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("you ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("can ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("eat ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("them ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("with ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("a ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("fork ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("or ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("(and ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("this ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("is ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("most ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("popular ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("way) ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("you ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("can ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("pop ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("entire ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("hull ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("into ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("your ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("mouth ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("and ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("use ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("your ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("teeth ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("to ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("split ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("shell ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("seam ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("and ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("extract ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("beans. ")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA40"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA40.w.0.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA40"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.41.0.0.box.370.316.1386.327.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA40.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_h1_heading",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "para.41.0.0.box.873.316.381.42.q.70"
    }
  }, [_vm._v("Sicilian Frittatas")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA40.w.0.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.41.0.1.box.370.430.1386.213.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA40.w.1.0.0"
    }
  }), _vm._v("In Italy, frittatas (thick omelets) are traditionally served cold for lunch. Wives make them early in the morning and wrap them up, and the men take them with them and slice them into wedges for the midday meal. I'm gonna teach y'all how to cook these the authentic way!")])]), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.41.1.0.box.371.725.1354.423.q.30"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA40.w.1.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA40.w.1.2.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA40.w.1.3.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA40.w.1.4.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA40.w.1.5.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA40.w.1.6.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA40.w.1.7.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA40.w.1.8.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0032.png"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA40.w.1.8.0.1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.41.2.0.box.370.1243.1386.1349.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA40.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.41.2.0.box.371.1243.1385.322.q.60"
    }
  }, [_vm._v("These are what are called your \"baseline ingredients.\" Regardless of the kind of frittata you make, you will have to start with these ingredients. The primary \"signature ingredients\"—shrimp, crabmeat, calamari, sausage, pork, chicken, spinach, sundried tomatoes, mushrooms, pasta, more cheese, or whatever else you like—are added once the baseline is in place.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA40.w.2.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.41.2.1.box.370.1574.1385.207.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA40.w.1.9.0"
    }
  }), _vm._v("So let's say you wanted to make an Italian sausage frittata. All you'd need to add to the baseline is Italian sausage (of course, you could drop in any combination of things you like with the sausage). And this is how the recipe would come together.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA40.w.2.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.41.2.2.box.370.1787.1386.264.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA40.w.1.10.0"
    }
  }), _vm._v("In a 10- or 12-in. nonstick skillet, heat the oil or butter until it begins to sizzle. Then drop in—and saute—the onions over mediumhigh heat until they just begin to caramelize (turn a light brown). Then when the onions are ready, put in your Italian sausage and cook it until it too begins to brown slightly.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA40.w.2.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.41.2.3.box.370.2057.1385.373.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA40.w.1.11.0"
    }
  }), _vm._v("Of course, while all this is happening, you should crack the eggs in a large mixing bowl, sprinkle on the Sicilian seasoning, salt, and pepper, pour in the water, and sprinkle on the Parmesan. Then whip the eggs to a froth! And when the Italian sausage is a beautiful golden brown, pour in the whipped eggs, lower the fire to medium, agitate the pan until the eggs settle evenly, and cook them for 4-6 minutes or until they begin to brown slightly around the perimeter.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA40.w.2.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.41.2.4.box.370.2436.1386.156.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA40.w.1.12.0"
    }
  }), _vm._v("When the bottom side of the frittata is done, place a dinner plate upside down in the skillet. Then flip the skillet and the frittata over into the plate, put the skillet back on the fire, slide the frittata off the"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA41.w.0.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.42.0.0.box.230.317.1387.204.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA41"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA41.w.0.0.0"
    }
  }), _vm._v("\nplate back into the skillet, and cook the other side of the frittata for another 4 minutes or so. When it's ready, serve it hot or cold, sprinkled over the top with a little extra Parmesan and sloshed with a little warm marinara sauce.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA41.w.1.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA41.w.1.0.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA41.w.1.1.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA41"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.42.0.0.box.230.317.1387.204.q.60"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.42.1.0.box.228.649.1401.649.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA41.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.42.1.0.box.285.649.251.37.q.70"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Chefs ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Note: ")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA41.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.42.1.1.box.234.703.1388.102.q.60"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("1")]), _vm._v("—"), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("How ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("big ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("a ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("frittata ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("can ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("you ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("make? ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("One ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("as ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("big ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("as ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("you ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("can ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("flip ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("over ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("onto ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("a ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("plate ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("without ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("making ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("a ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("mess ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("in ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("kitchen. ")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA41.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.42.1.2.box.228.811.1395.268.q.40"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA41.w.1.2.0"
    }
  }), _vm._v("2")]), _vm._v("—"), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("You ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("can ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("make ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("spaghetti ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("frittatas, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("sundried ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("tomato ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("frittatas, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("spinach ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("frittatas, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("chorizo ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("frittatas, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("salami ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("frittatas, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("anchovy ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("frittatas")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v(".")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v(".")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v(". ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("in ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("fact, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("I ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("can't ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("imagine ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("a ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("signature ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("ingredient ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("you ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("could ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("not ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("fashion ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("into ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("a ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("frittata. ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Salmon, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("shrimp, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("crabmeat, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("prosciutto, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("ham, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("garlic, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("egg")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("plant, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("potato, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("green ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("onion, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("whew!")]), _vm._v("—"), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("list ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("goes ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("on. ")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA41.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.42.1.3.box.236.1083.1393.215.q.50"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA41.w.1.3.0"
    }
  }), _vm._v("3")]), _vm._v("—"), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Never ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("add ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("milk ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("to ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("a ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("scrambled-egg ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("mix! ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Milk ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("tends ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("to ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("tough")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("en ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("egg. ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Instead, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("add ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("1 ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("tbsp. ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("bottled ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("water ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("for ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("every ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("egg ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("you ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("whip. ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("The ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("water ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("expands ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("egg ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("and ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("makes ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("it ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("light. ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Just ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("a ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("little ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("secret ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("I ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("thought ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("you'd ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("want ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("to ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("know. ")])])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.42.2.0.box.235.1514.1388.656.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA41.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_h1_heading",
    attrs: {
      "id": "para.42.2.0.box.357.1514.1140.52.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA41.w.2.0.0"
    }
  }), _vm._v("Mid-City Banana and Peanut Butter Sandwich")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA41.w.2.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.42.2.1.box.235.1628.1388.542.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA41.w.2.1.0"
    }
  }), _vm._v("If you were born in the Crescent City, if you grew up here, if you've always lived here, you've no doubt had all four of the famous New Orl"), _c('a', {
    attrs: {
      "id": "GBS.PA41.w.3.0.0"
    }
  }), _vm._v("eans sandwiches on the following pages. If you haven't, then I'm sorry . . . but there's just no way you can honestly call yourself Naturally N'Awlins until you've savor"), _c('a', {
    attrs: {
      "id": "GBS.PA41.w.3.1.0"
    }
  }), _vm._v("ed each one of them! This traditional neighborhood sandwich from Mid-City can be done one of two ways: (1) you can fix the banana au naturel right "), _c('a', {
    attrs: {
      "id": "GBS.PA41.w.3.2.0"
    }
  }), _vm._v("out of the peel, or (2) you can slice and pan-fry the banana in margarine first. My version has the margarine, but either way, it's a great sandwich and reminiscent of your childhood.")]), _c('a', {
    attrs: {
      "id": "GBS.PA41.w.4.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.42.3.0.box.240.2253.1296.147.q.40"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA42"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA42.w.0.0.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0033.png"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA42.w.0.0.0.1"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA42"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.43.0.0.box.358.316.1399.1351.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA42.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.43.0.0.box.360.316.1387.263.q.60"
    }
  }, [_vm._v("In a heavy skillet, heat the margarine until it sizzles. Then, place the banana slices into the pan and quickly fry them on both sides, flipping them gently with an egg turner so that they don't break apart in the middle (if you're good at it, you should be able to get 3 slices out of 1 medium banana).")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA42.w.0.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.43.0.1.box.360.590.1387.363.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA42.w.0.1.0"
    }
  }), _vm._v("While the bananas are frying, lay out the bread on the countertop and evenly and thinly spread the peanut butter on both slices (the peanut butter needs to be soft to do this; otherwise you'll rip the bread every time!). Then when the bananas are ready, take the egg turner, lift all the strips from the pan one at a time, place each on top of one slice of bread, and cover the bananas with the other slice of bread to form the sandwich.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA42.w.0.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.43.0.2.box.360.971.1386.269.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA42.w.0.2.0"
    }
  }), _vm._v("All that's left is to press down on the sandwich with your hands, thereby wedging the bananas into the peanut butter and sealing the edges of the bread. And presto! An ol'-fashioned banana and peanut butter sandwich like we made as kids! Of course, I don't have to tell you that this calls for cold chocolate milk, right?")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA42.w.0.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.43.0.3.box.358.1300.1399.367.q.60"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA42.w.0.3.0"
    }
  }), _vm._v("Variation: ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("If ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("you ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("ever ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("end ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("up ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("with ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("a ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("couple ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("of ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("bananas ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("that ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("are ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("super ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("overripe ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("(you ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("know, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("black ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("mushy ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("ones!), ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("peel ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("them, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("place ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("them ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("on ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("a ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("dinner ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("plate, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("smush ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("them ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("all ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("up ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("with ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("a ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("fork, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("and ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("make ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("yourself ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("a ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("sandwich ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("by ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("spreading ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("ripe ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("banana ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("on ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("one ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("slice ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("of ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("bread ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("and ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("peanut ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("butter ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("on ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("another ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("slice ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("of ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("bread ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("and ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("smashing ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("2 ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("slices ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("together. ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("This ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("we ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("always ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("called ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("a ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("\"Peanut ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Butter ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("and ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Banana ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Quickie.")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("\" ")])])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.43.1.0.box.361.1889.1385.380.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA42.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_h1_heading",
    attrs: {
      "id": "para.43.1.0.box.513.1889.1080.50.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA42.w.1.0.0"
    }
  }), _vm._v("Momma's Tomato and Mynaze Sandwiches")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA42.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.43.1.1.box.361.2004.1385.265.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA42.w.1.1.0"
    }
  }), _vm._v("I remember lots of days as a kid when twelve o'clock rolled"), _c('a', {
    attrs: {
      "id": "GBS.PA42.w.1.2.0"
    }
  }), _vm._v(" around and we had no luncheon meat for sandwiches (and couldn't afford any either)."), _c('a', {
    attrs: {
      "id": "GBS.PA42.w.1.3.0"
    }
  }), _vm._v(" But nobody was gonna go hungry! Momma called us inside, even let us invite our frie"), _c('a', {
    attrs: {
      "id": "GBS.PA42.w.1.4.0"
    }
  }), _vm._v("nds, and whipped up some of the tastiest Old New Orleans sandwiches I ever ate: tomato and mynaze.")]), _c('a', {
    attrs: {
      "id": "GBS.PA42.w.2.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.43.2.0.box.361.2367.1351.202.q.40"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA43"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA43.w.0.0.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0034.png"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA43.w.0.0.0.1"
    }
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA43.w.0.0.0.2"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA43.w.0.1.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA43"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.44.0.0.box.228.306.1396.541.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA43.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.44.0.0.box.229.306.1388.324.q.50"
    }
  }, [_vm._v("With the bread laid out on the countertop, slather the mynaze liberally on each slice. Then with a really sharp knife, cut the tomato into rounds about 1A in. thick. When the slicing is done, place several rounds on 2 slices of bread (it's okay to overlap the rounds), sprinkle them liberally with salt and pepper, and top with the other 2 slices of bread, thereby creating 2 sandwiches (they're so good you gotta have 2!).")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA43.w.0.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.44.0.1.box.228.688.1396.159.q.50"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Chefs ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Note: ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("We ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("usta ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("make ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("a ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("variation ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("of ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("this ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("sandwich ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("using ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("green ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("tomatoes ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("that ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Momma ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("would ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("slice, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("dip ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("in ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("egg, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("coat ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("with ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("bread")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("crumbs, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("and ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("pan-fry! ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("But ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("that's ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("another ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("recipe ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("for ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("another ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("time. ")])])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.44.1.0.box.232.1064.1389.382.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA43.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_h1_heading",
    attrs: {
      "id": "para.44.1.0.box.565.1064.718.51.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA43.w.1.0.0"
    }
  }), _vm._v("Tuesday Red Bean Sandwich")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA43.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.44.1.1.box.232.1179.1389.267.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA43.w.2.0.0"
    }
  }), _vm._v("Monday has always been red beans and rice day in N'Awlins. And usually there is just a little bit of the red beans left over in the refrigerator come Tuesday morning. Well, when I was growing up, that was the main ingredient of the sandwich you brought with you to school every Tuesday for lunch. Remember how it was made?")])]), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.44.2.0.box.237.1524.1297.98.q.40"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA43.w.2.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA43.w.2.2.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA43.w.2.3.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0035.png"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA43.w.2.3.0.1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.44.3.0.box.235.1703.1395.852.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA43.w.3.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.44.3.0.box.235.1703.1386.159.q.60"
    }
  }, [_vm._v("First take the heel of the French bread (some folks call it the toe) and dig out the soft bread inside the outer crust. Then, \"butter\" the inside of the heel. It is important that you distribute the margarine evenly.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA43.w.3.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.44.3.1.box.235.1867.1394.266.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA43.w.2.4.0"
    }
  }), _vm._v("When the \"cone\" is properly prepared, take the red beans—"), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("cold ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("and ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("straight ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("from ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("refrigerator")]), _vm._v("—and begin to pack them into the French bread cone with a tablespoon, forcing them in tightly as you stuff. Then when the bread is filled to capacity, smooth off the top and wrap the cone tightly and securely with plastic wrap or waxed paper.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA43.w.3.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.44.3.2.box.236.2137.1386.93.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA43.w.2.5.0"
    }
  }), _vm._v("On Tuesdays in New Orleans, lunchtime was like having \"ice cream.\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA43.w.3.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.44.3.3.box.237.2301.1393.254.q.60"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA43.w.2.6.0"
    }
  }), _vm._v("Chef's ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Note: ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("I ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("remember ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("that ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("a ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("few ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("guys ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("who ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("ate ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("red ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("bean ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("sand")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("wiches ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("at ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("school ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("always ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("had ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("them ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("hot. ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("They ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("musta ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("known ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("cafe")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("teria ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("ladies ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("or ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("something. ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Mine ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("was ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("always ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("traditional")]), _vm._v("—"), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("cold ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("and ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("creamy. ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("And ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("every ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("now ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("and ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("then ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Momma ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("hid ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("a ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("piece ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("of ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("pickled ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("meat ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("down ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("in ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("middle ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("for ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("me! ")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA44"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA44.w.0.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA44"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.45.0.0.box.307.317.1386.543.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA44.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_h1_heading",
    attrs: {
      "id": "para.45.0.0.box.576.317.847.50.q.70"
    }
  }, [_vm._v("That Famous Fried Potato Po' Boy")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA44.w.0.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.45.0.1.box.307.431.1386.429.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA44.w.1.0.0"
    }
  }), _vm._v("It was the sandwich that fed New Orleans during the Great Depression. Martin Brothers Restaurant is said to have been the originator; but Herschtel's on St. Claude also made and served them by the thousands! They were a foot long and cost 15 cents. The story goes that workmen would buy one, have it cut in half, eat one half for their lunch, and bring the other half home to the wife for supper. Real restaurants that maintain New Orleans traditions still serve them today.")])]), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.45.1.0.box.305.947.1342.198.q.40"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA44.w.1.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA44.w.1.2.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA44.w.1.3.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA44.w.1.4.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0036.png"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA44.w.1.4.0.1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.45.2.0.box.307.1237.1398.1078.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA44.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.45.2.0.box.307.1237.1384.211.q.50"
    }
  }, [_vm._v("First, take a trypan, fill it with enough oil to cover the potatoes when you drop them in, and bring it up to 350 degrees. Then drop in the potato strips (or rounds) and deep-fry them until they turn a golden brown.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA44.w.2.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.45.2.1.box.307.1453.1385.158.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA44.w.1.5.0"
    }
  }), _vm._v("In the meantime, while the potatoes are cooking, slice the French bread down the middle, separate the top from the bottom, and liberally slather both with mayonnaise.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA44.w.2.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.45.2.2.box.308.1617.1385.211.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA44.w.1.6.0"
    }
  }), _vm._v("Then, when the potatoes are done, remove them from the trypan, drain them on several thicknesses of paper towels, and arrange them on one half of the French bread. And you need to be generous, too— "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("don")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("'t ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("skimp ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("on ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("spuds. ")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA44.w.2.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.45.2.3.box.308.1834.1383.157.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA44.w.1.7.0"
    }
  }), _vm._v("Then, right before the time when you're ready to put the lid on the sandwich, take a ladle and pour roast-beef gravy over the potatoes, sprinkle with salt and pepper, and serve up the treat piping hot.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA44.w.2.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.45.2.4.box.309.2050.1396.265.q.50"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA44.w.1.8.0"
    }
  }), _vm._v("Chef's ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Note: ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("It's ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("okay ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("these ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("days ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("to ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("dress ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("potato ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("po' ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("boy ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("with ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("lettuce ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("and ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("tomato ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("if ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("you ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("want ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("to; ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("but ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("original ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("was ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("comprised ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("of ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("nothing ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("but ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("fried ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("potatoes, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("mayonnaise, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("and ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("gravy, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("something ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("old-timers ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("referred ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("to ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("as ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("a ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("\"wish ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("sandwich.")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("\" ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("You ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("ate ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("potatoes, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("but ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("you ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("wished ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("you ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("had ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("some ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA44.w.2.0.0"
    }
  }), _vm._v("meat! ")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA45"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA45.w.0.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA45.w.0.0.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA45.w.1.0.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA45"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.46.0.0.box.234.312.1390.437.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA45.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_h1_heading",
    attrs: {
      "id": "para.46.0.0.box.612.312.635.54.q.70"
    }
  }, [_vm._v("Superbowl Crabmeat Dip")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA45.w.0.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.46.0.1.box.234.427.1390.322.q.60"
    }
  }, [_vm._v("This dip and the other \"super dips\" that follow should be set out for your family and friends come Superbowl Sunday. And with nothing more than a food processor, you can make them all with little or no effort. Oh, yeah—and they really don't have to be served just at Superbowl time . . . they're mouth-wateringly fantastic every day of the football season and all year long.")])]), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.46.1.0.box.238.836.1386.481.q.30"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA45.w.2.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA45.w.2.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA45.w.2.2.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA45.w.2.3.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA45.w.2.4.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA45.w.2.5.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA45.w.2.6.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA45.w.3.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA45.w.3.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA45.w.4.0.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0037.png"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA45.w.4.0.0.1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.46.2.0.box.240.1403.1389.869.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA45.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.46.2.0.box.240.1403.1388.379.q.60"
    }
  }, [_vm._v("Into the work bowl of your food processor, drop in the cream cheese (it works best if you allow the blocks first to come to room temperature and then break them into small chunks). Then add in the hot sauce, half-and-half, lobster base, and seafood seasoning and turn the machine on. Ideally, you want to \"cream\" the mixture to a silky-smooth consistency (but don't make it watery). About 1-2 minutes at full speed should do nicely.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA45.w.2.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.46.2.1.box.241.1786.1387.269.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA45.w.4.1.0"
    }
  }), _vm._v("Next, transfer the cream-cheese base to a large mixing bowl. Then with a rubber spatula fold in the onions, garlic, green onions, parsley, and crabmeat, mixing everything until fully and uniformly blended. At this point, taste the mixture and adjust the salt and pepper if necessary.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA45.w.2.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.46.2.2.box.242.2060.1387.212.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA45.w.4.2.0"
    }
  }), _vm._v("Finally, place the finished dip into a serving bowl, sprinkle the top lightly with paprika, cover tightly with plastic wrap, and stash in the refrigerator for at least 3 hours for the flavors to \"marry\" before serving. The dip is best if served chilled with crispy tortilla chips.")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.46.3.0.box.243.2330.1393.265.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA45.w.3.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.46.3.0.box.297.2330.250.37.q.70"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA45.w.5.0.0"
    }
  }), _vm._v("Chef's ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Note: ")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA45.w.3.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.46.3.1.box.243.2384.1391.102.q.60"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA45.w.5.1.0"
    }
  }), _vm._v("1")]), _vm._v("—"), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("The ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("lobster ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("and ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("chicken ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("base, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("while ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("ordinarily ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("available ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("only ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("to ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("restaurateurs, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("is ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("sold ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("to ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("public ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("at ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("a ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("number ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("of ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("specialty ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("food ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("centers. ")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA45.w.3.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.46.3.2.box.244.2492.1392.103.q.50"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA45.w.5.2.0"
    }
  }), _vm._v("2")]), _vm._v("—"), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Only ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("a ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("food ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("processor ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("will ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("produce ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("consistency ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("necessary ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("for ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("dip. ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("A ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("blender ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("will ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("not ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("mix ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("thoroughly ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("enough. ")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA46"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA46.w.0.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA46"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.47.0.0.box.354.314.1388.213.q.40"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA46.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.47.0.0.box.354.314.1388.104.q.60"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("3")]), _vm._v("—"), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("The ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("flavor ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("of ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("this ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("dip ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("is ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("far ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("more ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("intense ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("with ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("claw ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("crabmeat ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("than ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("any ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("other ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("kind. ")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA46.w.0.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.47.0.1.box.355.427.1385.100.q.40"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA46.w.0.1.0"
    }
  }), _vm._v("4")]), _vm._v("—"), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("For ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("a ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("little ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("extra ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("tartness, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("spoon ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("about ")]), _vm._v("1/> "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("cup ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("sour ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("cream ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("into ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("finished ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("dip. ")])])]), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.47.1.0.box.352.745.1370.656.q.30"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA46.w.1.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA46.w.2.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA46.w.2.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA46.w.2.2.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA46.w.2.3.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA46.w.2.4.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA46.w.2.5.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA46.w.2.6.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA46.w.3.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA46.w.3.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA46.w.3.2.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA46.w.3.3.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA46.w.3.4.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA46.w.3.5.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA46.w.3.6.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA46.w.3.7.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA46.w.4.0.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0038.png"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA46.w.4.0.0.1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.47.2.0.box.352.1484.1390.1129.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA46.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.47.2.0.box.352.1484.1390.264.q.60"
    }
  }, [_vm._v("First, in a 12-in. nonstick skillet, heat the butter to sizzling over a high flame. Then a few at a time drop in the shrimp and saute them until they turn pink all over—"), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("but ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("do ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("not ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("overcook ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("them ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("or ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("they'll ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("turn ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("rubbery! ")]), _vm._v("When they're done, remove them from the skillet, let them cool, and then chop them into small pieces.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA46.w.2.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.47.2.1.box.352.1754.1384.373.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA46.w.4.1.0"
    }
  }), _vm._v("Meanwhile, into the work bowl of your food processor, drop in the cream cheese (it works best if you first allow the blocks to come to room temperature and then break them into small chunks). Then add in the hot sauce, half-and-half, lobster base, and seafood seasoning and turn the machine on. Ideally, you want to \"cream\" the mixture to a silky-smooth consistency (but don't make it watery). About 1-2 minutes at full speed should do nicely.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA46.w.2.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.47.2.2.box.353.2133.1384.264.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA46.w.4.2.0"
    }
  }), _vm._v("Next, transfer the cream-cheese base to a large mixing bowl. Then with a rubber spatula fold in the onions, garlic, green onions, parsley, shrimp, and shrimp drippings. Then mix everything until fully and uniformly blended. At this point, taste the mixture and adjust the salt and pepper if necessary.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA46.w.2.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.47.2.3.box.352.2403.1384.210.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA46.w.4.3.0"
    }
  }), _vm._v("Finally, place the finished dip into a serving bowl, sprinkle the top lightly with paprika, cover tightly with plastic wrap, and stash in the refrigerator for at least 3 hours for the flavors to \"marry\" before serving. The dip is best if served chilled with crispy tortilla chips.")])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA47"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA47.w.0.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA47.w.0.0.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA47.w.1.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA47.w.2.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA47.w.2.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA47.w.2.2.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA47.w.2.3.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA47.w.2.4.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA47.w.2.5.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA47.w.2.6.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA47.w.2.7.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA47"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.48.0.0.box.240.317.1399.268.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA47.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.48.0.0.box.240.317.1399.268.q.60"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Chefs ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Note: ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("The ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("shrimp ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("flavor ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("in ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("this ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("recipe ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("is ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("far ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("more ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("intense ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("with ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("butter-sauteed ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("shrimp ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("as ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("opposed ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("to ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("poached ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("or ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("boiled ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("shrimp. ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Just ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("take ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("care ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("to ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("control ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("amount ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("of ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("pan ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("drippings ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("you ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("add ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("to ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("cream-cheese ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("base—")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("you ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("don't ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("want ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("mix ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("runny. ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("For ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("other ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("helpful ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("tips, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("see ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Chef's ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Note ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("for ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Superbowl ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Crabmeat ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Dip ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("above. ")])])]), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.48.1.0.box.247.803.1372.597.q.30"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA47.w.2.8.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0039.png"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA47.w.2.8.0.1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.48.2.0.box.247.1485.1390.1136.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA47.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.48.2.0.box.247.1485.1388.268.q.60"
    }
  }, [_vm._v("First, place the crawfish in the food processor. Then, using the pulse device, continually start and stop the blades quickly to mince the tails (just be sure you don't overprocess, though—you do not want the crawfish pureed). When they're ready, remove them from the processor's work bowl and transfer them to a large mixing bowl.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA47.w.2.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.48.2.1.box.249.1759.1386.376.q.60"
    }
  }, [_vm._v("In the meantime, put the work bowl back on your food processor ("), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("do ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("not ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("clean ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("a ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("way ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("cra ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("wfish ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("fat ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("from ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("walls ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("of ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("bo ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("wl)")]), _vm._v(". Then drop in the cream cheese (softened and broken into small chunks), add in the hot sauce, half-and-half, lobster base, and seafood seasoning, and turn the machine on. Ideally, you want to \"cream\" the mixture to a silky-smooth consistency (but don't make it watery). About 1-2 minutes at full speed should do nicely.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA47.w.2.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.48.2.2.box.249.2141.1388.263.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA47.w.2.9.0"
    }
  }), _vm._v("Next, transfer the cream-cheese base to a large mixing bowl. Then with a rubber spatula fold in the onions, garlic, green onions, parsley, and crawfish. Then mix everything until fully and uniformly blended. At this point, taste the mixture and adjust the salt and pepper if necessary.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA47.w.2.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.48.2.3.box.249.2410.1387.211.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA47.w.2.10.0"
    }
  }), _vm._v("Finally, place the finished dip into a serving bowl, sprinkle the top lightly with paprika, cover tightly with plastic wrap, and stash in the refrigerator for at least 3 hours for the flavors to \"marry\" before serving. The dip is best if served chilled with crispy tortilla chips.")])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA48"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA48.w.0.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA48"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.49.0.0.box.350.317.1390.211.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA48.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.49.0.0.box.350.317.1390.211.q.60"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Chef's ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Note: ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("The ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("crawfish ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("flavor ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("in ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("this ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("recipe ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("becomes ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("intense ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("only ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("after ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("resting ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("in ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("refrigerator ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("for ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("several ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("hours. ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Try ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("to ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("give ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("it ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("time ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("to ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("develop. ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("For ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("other ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("helpful ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("tips, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("see ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Chefs ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Note ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("for ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Superbowl ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Crabmeat ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Dip ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("above. ")])])]), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.49.1.0.box.349.748.1382.597.q.10"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA48.w.1.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA48.w.2.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA48.w.2.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA48.w.2.2.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA48.w.2.3.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA48.w.2.4.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA48.w.2.5.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA48.w.2.6.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA48.w.2.7.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA48.w.2.8.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0040.png"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA48.w.2.8.0.1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.49.2.0.box.347.1435.1395.1124.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA48.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.49.2.0.box.348.1435.1384.318.q.60"
    }
  }, [_vm._v("First, place the work bowl and blades onto your food processor. Then drop in the cream cheese (broken into small chunks) and add in the hot sauce, half-and-half, chicken base, and sprinkling spice. Then turn the machine on. Ideally, you want to \"cream\" the mixture to a silky-smooth consistency (but don't make it watery). About 1-2 minutes at full speed should do nicely.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA48.w.2.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.49.2.1.box.348.1759.1385.265.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA48.w.2.9.0"
    }
  }), _vm._v("Next, transfer the cream-cheese base to a large mixing bowl. Then with a rubber spatula fold in the onions, garlic, green onions, parsley, ham, and cheese. Then mix everything until fully and uniformly blended. At this point, taste the mixture and adjust the salt and pepper if necessary.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA48.w.2.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.49.2.2.box.349.2030.1384.211.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA48.w.2.10.0"
    }
  }), _vm._v("Finally, place the finished dip into a serving bowl, sprinkle the top lightly with paprika, cover tightly with plastic wrap, and stash in the refrigerator for at least 3 hours for the flavors to \"marry\" before serving. The dip is best if served chilled with crispy tortilla chips.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA48.w.2.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.49.2.3.box.347.2300.1395.259.q.60"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA48.w.2.11.0"
    }
  }), _vm._v("Chef's ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Note: ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("The ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("ham ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("and ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("cheese ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("flavor ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("in ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("this ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("recipe ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("becomes ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("intense ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("only ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("after ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("it ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("rests ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("in ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("refrigerator ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("for ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("several ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("hours. ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Try ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("to ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("give ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("it ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("time ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("to ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("develop. ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("For ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("other ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("helpful ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("tips, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("see ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Chef's ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Note ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("for ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Superbowl ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Crabmeat ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Dip ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("above ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("(but ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("don't ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("try ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("any ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("sour ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("cream ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("in ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("this ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("one). ")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA49"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA49.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA49.w.0.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA49.w.0.2.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA49.w.0.3.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA49.w.0.4.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA49.w.0.5.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA49.w.0.6.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA49.w.0.7.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA49.w.0.8.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA49.w.0.9.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA49.w.0.9.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA49.w.0.10.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA49"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.50.0.0.box.243.314.1384.600.q.30"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA49.w.0.11.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0041.png"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA49.w.0.11.0.1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.50.1.0.box.243.1005.1397.1251.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA49.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.50.1.0.box.243.1005.1389.322.q.60"
    }
  }, [_vm._v("First, place the work bowl and blades on your food processor. Then drop in the cream cheese (broken into small chunks) and add in the hot sauce, half-and-half, chicken base, and poultry seasoning. Then turn the machine on. Ideally, you want to \"cream\" the mixture to a silky-smooth consistency (but don't make it watery). About 1-2 minutes at full speed should do nicely.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA49.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.50.1.1.box.245.1332.1387.268.q.60"
    }
  }, [_vm._v("Next, transfer the cream-cheese base to a large mixing bowl. Then with a rubber spatula fold in the onions, garlic, green onions, parsley, and chicken. Then mix everything until fully and uniformly blended. At this point, taste the mixture and adjust the salt and pepper if necessary.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA49.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.50.1.2.box.245.1606.1387.213.q.60"
    }
  }, [_vm._v("Finally, place the finished dip into a serving bowl, sprinkle the top lightly with paprika, cover tightly with plastic wrap, and stash in the refrigerator for at least 3 hours for the flavors to \"marry\" before serving. The dip is best if served chilled with crispy tortilla chips.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA49.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.50.1.3.box.300.1880.250.36.q.70"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA49.w.0.12.0"
    }
  }), _vm._v("Chefs ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Note: ")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA49.w.1.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.50.1.4.box.246.1934.1394.103.q.60"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA49.w.0.13.0"
    }
  }), _vm._v("1")]), _vm._v("—"), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("The ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("chicken ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("flavor ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("in ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("this ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("recipe ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("becomes ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("intense ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("only ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("after ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("it ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("rests ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("in ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("refrigerator ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("for ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("several ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("hours. ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Try ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("to ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("give ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("it ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("time ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("to ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("develop. ")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA49.w.1.5.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.50.1.5.box.246.2043.1391.103.q.70"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA49.w.0.14.0"
    }
  }), _vm._v("2")]), _vm._v("—"), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("For ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("a ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("little ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("extra ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("flavor, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("whip ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("in ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("some ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("of ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("drippings ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("from ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("roasting ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("pan ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("and ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("top ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("dip ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("with ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("a ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("sprinkling ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("of ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("bacon ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("bits. ")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA49.w.1.6.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.50.1.6.box.249.2152.1389.104.q.50"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA49.w.0.15.0"
    }
  }), _vm._v("3")]), _vm._v("—"), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("As ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("a ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("variation, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("chicken ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("can ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("be ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("processed ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("along ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("with ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("cream ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("cheese ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("to ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("produce ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("a ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("creamy ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("(instead ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("of ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("chunky) ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("chicken ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("dip. ")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA50"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA50.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA50.w.1.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA50.w.1.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA50.w.1.2.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA50.w.1.3.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA50.w.1.4.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA50.w.2.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA50.w.2.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA50.w.2.2.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA50.w.2.3.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA50.w.2.4.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA50.w.2.5.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA50.w.2.6.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA50.w.3.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA50"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.51.0.0.box.353.316.1370.704.q.30"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA50.w.3.1.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0042.png"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA50.w.3.1.0.1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.51.1.0.box.350.1111.1391.1456.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA50.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.51.1.0.box.351.1111.1385.362.q.50"
    }
  }, [_vm._v("First, cook down the spinach in a saucepan with just enough chicken or vegetable stock to create a scant amount of poaching liquid (but do not boil it!). You want to end up with 1 cup of poached spinach. About 4-5 minutes cooking time should do. Then while the spinach is on the stove, drain the artichoke hearts and mince them to make 1 cup. When everything is ready, set it aside until you prepare your cream-cheese base.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA50.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.51.1.1.box.351.1491.1385.320.q.60"
    }
  }, [_vm._v("To do that, place the work bowl and blades on your food processor. Then drop in the cream cheese (broken into small chunks) and add in hot sauce, half-and-half, bell pepper or chicken base, and vegetable seasoning. Then turn the machine on. Ideally, you want to \"cream\" the mixture to a silky-smooth consistency (but don't make it watery). About 1-2 minutes at full speed should do nicely.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA50.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.51.1.2.box.350.1815.1384.267.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA50.w.3.2.0"
    }
  }), _vm._v("Next, transfer the cream-cheese base to a large mixing bowl. Then with a rubber spatula fold in the onions, garlic, green onions, parsley, spinach (squeezed dry and chopped to make 1 cup), and artichokes. Then mix everything until fully and uniformly blended. At this point, taste the mixture and adjust for salt and pepper if necessary.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA50.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.51.1.3.box.350.2086.1384.212.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA50.w.3.3.0"
    }
  }), _vm._v("Finally, place the finished dip into a serving bowl, sprinkle the top lightly with paprika and bacon bits, cover tightly with plastic wrap, and stash in the refrigerator for at least 3 hours for the flavors to \"marry\" before serving. The dip is best if served chilled with crispy tortilla chips.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA50.w.1.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.51.1.4.box.351.2357.1390.210.q.60"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA50.w.3.4.0"
    }
  }), _vm._v("Chefs ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Note: ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("The ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("spinach ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("and ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("artichoke ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("fla ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("vor ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("in ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("this ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("recipe ")]), _c('i', [_vm._v("won' ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("t ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("really ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("intensify ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("until ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("after ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("dip ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("rests ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("in ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("refrigerator ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("for ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("several ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("hours. ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Try ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("to ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("give ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("it ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("time ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("to ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("develop. ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("For ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("other ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("helpful ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("tips, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("see ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Chef's ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Note ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("for ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Superbowl ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Crabmeat ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Dip ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("above. ")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA51"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA51.w.0.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA51.w.0.0.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA51.w.0.1.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA51"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.52.0.0.box.239.309.1388.430.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA51.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_h1_heading",
    attrs: {
      "id": "para.52.0.0.box.431.309.1003.52.q.80"
    }
  }, [_vm._v("Frank's Mamacita-Approved Guacamole")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA51.w.0.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.52.0.1.box.239.426.1388.313.q.60"
    }
  }, [_vm._v("If you grew up in New Orleans dearly loving alligator pears, you probably ate them right out of the peel with a splash of lemon juice, a little garlic hot sauce, and a sprinkle of salt and black pepper. Well, you can add this here recipe for real guacamole, which couldn't be any better if your name was Manuel Ortega Poncho Fernando Hernandez Carlos Jose Raoul Garcia Martinez!")])]), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.52.1.0.box.240.816.1226.258.q.40"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA51.w.0.2.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA51.w.0.3.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA51.w.0.4.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA51.w.0.5.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA51.w.0.6.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA51.w.0.7.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0043.png"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA51.w.0.7.0.1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.52.2.0.box.239.1163.1397.1081.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA51.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.52.2.0.box.240.1163.1387.200.q.60"
    }
  }, [_vm._v("In a large bowl, mix together the onions, peppers, and tomatoes until thoroughly blended. Then, "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("using ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("a ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("fork, ")]), _vm._v("slightly mash the alligator pears into a semi-chunky paste and fold it into the vegetable mixture.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA51.w.2.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.52.2.1.box.240.1380.1392.266.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA51.w.0.8.0"
    }
  }), _vm._v("At this point, "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("gently ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("fold ")]), _vm._v("in all the remaining ingredients until thoroughly blended ... "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("but ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("do ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("not ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("overstir ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("and ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("do ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("not ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("overcream ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("alligator ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("pears. ")]), _vm._v("Whatever you do, do not turn the mix into a soupy sauce (unless, of course, you plan to use it for a delicate salad dressing—see below)!")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA51.w.2.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.52.2.2.box.241.1652.1386.104.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA51.w.0.9.0"
    }
  }), _vm._v("Finally, cover the mixture, put it into the refrigerator, and chill it about 4 hours before serving it with tortilla chips or nachos.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA51.w.2.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.52.2.3.box.295.1816.250.37.q.70"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA51.w.0.10.0"
    }
  }), _vm._v("Chef's ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Note: ")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA51.w.2.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.52.2.4.box.241.1871.1395.145.q.40"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA51.w.0.11.0"
    }
  }), _vm._v("1")]), _vm._v("—"), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("First ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("of ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("all, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("if ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("you're ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("not ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("from ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("here ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("and ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("you ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("never ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("had ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("a ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("New ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Orleans ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("mawmaw, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("you ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("probably ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("know ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("alligator ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("pears ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("by ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("their ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("other ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("name")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v(".")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v(".")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v(". ")]), _vm._v("avocados.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA51.w.2.5.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.52.2.5.box.239.2034.1394.210.q.60"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA51.w.0.12.0"
    }
  }), _vm._v("2")]), _vm._v("—"), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("With ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("that ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("out ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("of ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("way, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("you ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("need ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("to ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("know ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("that ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("this ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("mix ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("is ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("good ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("not ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("only ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("as ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("a ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA51.w.1.0.0"
    }
  }), _vm._v("guacamole ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("dip ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("or ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("as ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("a ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("topping ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("for ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("fajitas ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("or ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("tacos, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("it ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("makes ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("an ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("excellent ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("salad ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("dressing ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA52"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA52.w.0.0.0"
    }
  }), _vm._v("(as ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("previously ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("mentioned) ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("as ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("well ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("as ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("a ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("unique ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("sauce ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("for ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("baked ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("chicken ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("or ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("grilled ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("shrimp. ")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA53"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA53.w.0.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA53.w.0.0.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA53.w.0.0.0.2"
    }
  })]), _c('div', {
    staticClass: "flow"
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA53.w.0.0.0.3"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8940eb3e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/content/content0044.vue
// module id = 63
// module chunks = 0